import { createModalStore } from '@/shared/lib/modal';

import { BannerStep } from '../lib/constants';

type ScreenRecordPromoBannerStoreData = {
  currentStep: BannerStep;
};

export const useScreenRecordPromoBannerStore = createModalStore<ScreenRecordPromoBannerStoreData>({
  currentStep: null,
});
